import { getJq } from 'www/core';
const $ = getJq();

function blockUI() {
  document.querySelector('body').classList.add('ui-disabled');
}

function unblockUI() {
  document.querySelector('body').classList.remove('ui-disabled');
  $('[data-disable-with],.block-ui-on-click').each(function() {
    // Prefer Rails UJS API when available; fallback to jQuery UJS if present
    if (window.Rails && typeof window.Rails.enableElement === 'function') {
      window.Rails.enableElement(this);
    } else if ($.rails && typeof $.rails.enableElement === 'function') {
      $.rails.enableElement($(this));
    }
    $(this).removeAttr('disabled');
  });
}

function setupUIBlocker() {
  // For elements with data-confirm, only block UI when the AJAX request actually starts
  // (after user confirms), not on the initial click
  document.addEventListener('ajax:before', function(event) {
    if (event.target.classList.contains('block-ui-on-click')) {
      blockUI();
    }
  }, true);

  // Use event delegation for click events (works with dynamically added elements after Turbo renders)
  document.addEventListener('click', function(event) {
    var target = event.target.closest('.block-ui-on-click');
    if (target) {
      // Only block immediately if there's no confirmation dialog
      if (!target.hasAttribute('data-confirm') && !target.closest('[data-confirm]')) {
        blockUI();
      }
    }
  }, true);

  // Rails UJS (remote: true forms and links) and Turbo
  // These events fire on the element; listen at document level and capture
  ['ajax:success', 'ajax:error', 'ajax:complete', 'turbo:submit-end'].forEach(function(evtName) {
    document.addEventListener(evtName, function(event) {
      window.unblockUI();
    }, true);
  });

  // Handle Turbo fetch events specifically
  document.addEventListener('turbo:before-fetch-request', function(event) {
    // Block UI when starting a Turbo request
    if (event.target.classList.contains('block-ui-on-click') || event.target.closest('.block-ui-on-click')) {
      blockUI();
    }
  }, true);

  document.addEventListener('turbo:before-fetch-response', function(event) {
    // Unblock UI when Turbo response is received
    if (event.target.classList.contains('block-ui-on-click') || event.target.closest('.block-ui-on-click')) {
      window.unblockUI();
    }
  }, true);

}

window.blockUI = blockUI;
window.unblockUI = unblockUI;
$(setupUIBlocker);
